class TableComparisonHighlight {
  constructor(block) {
    this.block = block;
    this.table = block.querySelector('.table-comparison-table');
    this.layer = this.table?.querySelector('.table-comparison-highlight-layer') || document.createElement('div');
    this.update = this.update.bind(this);

    if (this.table && !this.layer.parentElement) {
      this.layer.className = 'table-comparison-highlight-layer';
      this.table.prepend(this.layer);
    }
  }

  connect() {
    this.update();
    window.addEventListener('resize', this.update);
    this.block.querySelectorAll('img').forEach((image) => {
      image.addEventListener('load', this.update, { once: true });
    });
  }

  disconnect() {
    window.removeEventListener('resize', this.update);
  }

  update() {
    if (!this.table || !this.layer) return;

    const highlightedColumn = this.block.dataset.highlightColumn;
    if (!highlightedColumn || highlightedColumn === 'none') {
      this.layer.hidden = true;
      return;
    }

    const headerCell = this.table.querySelector(`.table-comparison-header-row > .table-comparison-cell-${highlightedColumn}`);
    const bodyCells = Array.from(this.table.querySelectorAll(`.table-comparison-row > .table-comparison-cell-${highlightedColumn}`));
    const lastBodyCell = bodyCells[bodyCells.length - 1];
    const firstCell = headerCell || bodyCells[0];
    const lastCell = lastBodyCell || headerCell;

    if (!firstCell || !lastCell) {
      this.layer.hidden = true;
      return;
    }

    const tableRect = this.table.getBoundingClientRect();
    const firstRect = firstCell.getBoundingClientRect();
    const lastRect = lastCell.getBoundingClientRect();
    const bottomOffset = 16;

    this.layer.hidden = false;
    this.layer.style.left = `${firstRect.left - tableRect.left}px`;
    this.layer.style.top = `${firstRect.top - tableRect.top}px`;
    this.layer.style.width = `${firstRect.width}px`;
    this.layer.style.height = `${lastRect.bottom - firstRect.top + bottomOffset}px`;
  }
}

const tableComparisonInstances = new WeakMap();

function initTableComparisons(root = document) {
  root.querySelectorAll('.table-comparison-block').forEach((block) => {
    const existingInstance = tableComparisonInstances.get(block);
    if (existingInstance) {
      existingInstance.update();
      return;
    }

    const instance = new TableComparisonHighlight(block);
    tableComparisonInstances.set(block, instance);
    instance.connect();
  });
}

document.addEventListener('DOMContentLoaded', () => initTableComparisons());
document.addEventListener('shopify:section:load', (event) => initTableComparisons(event.target));
